_auth$toJS